import {
  FETCHING_VIDEOS,
  FETCHING_PLAYLISTS,
  FETCHING_PLAYLIST_DETAILS,
  FETCHING_CATEGORIES,
  FETCHING_RENTED_PLAYLISTS,
  VOD_VIDEO,
  VOD_VIDEOS,
  VOD_VIDEO_ERROR,
  VOD_VIDEOS_ERROR,
  VOD_PLAYLISTS,
  VOD_PLAYLISTS_ERROR,
  VOD_PLAYLIST_DETAILS,
  VOD_PLAYLIST_DETAILS_ERROR,
  VOD_RENTED_VIDEOS,
  VOD_RENTED_PLAYLISTS,
  FETCHING_RENTED_VIDEOS,
  VOD_CATEGORIES,
  VOD_CATEGORIES_ERROR
} from 'Constants'
import { store } from '../store.index'

import { client } from './client'
const axios = client()
import { API_ROOT } from 'Config'

let axiosConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem('customerkey')
  }
}

export function startFetchingVideos() {
  return {
    type: FETCHING_VIDEOS
  }
}

export function startFetchingRentedVideos() {
  return {
    type: FETCHING_RENTED_VIDEOS
  }
}

export function startFetchingPlaylists() {
  return {
    type: FETCHING_PLAYLISTS
  }
}

export function startFetchingPlaylistDetails() {
  return {
    type: FETCHING_PLAYLIST_DETAILS
  }
}

export function startFetchingCategories() {
  return {
    type: FETCHING_CATEGORIES
  }
}

export function startFetchingRentedPlaylists() {
  return {
    type: FETCHING_RENTED_PLAYLISTS
  }
}

export function getPlaylists() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/playlists`

  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    dispatch({ type: FETCHING_PLAYLISTS })
    request
      .then(({ data }) => {
        dispatch({ type: VOD_PLAYLISTS, payload: data.data })
      })
      .catch(err => {
        dispatch({ type: VOD_PLAYLISTS_ERROR, payload: err })
      })
  }
}

export function getVideoCategories() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  const requestUrl = `${API_ROOT}/api/embed/categories/vod`

  const request = axios.get(requestUrl, axiosConfig)

  return dispatch => {
    dispatch({ type: FETCHING_CATEGORIES })
    request
      .then(({ data }) => {
        dispatch({ type: VOD_CATEGORIES, payload: data.data })
      })
      .catch(err => {
        dispatch({ type: VOD_CATEGORIES_ERROR, payload: err })
      })
  }
}

export function getVideos(postData) {
  let region_id = localStorage.getItem('region_id')
  let url_prefix = store.getState().accountreducer.urlPrefix

  let filterData = {
    user_id: postData.filters.user_id,
    duration:
      postData.filters.duration &&
      postData.filters.duration.map(dur => {
        return { gte: dur.split(',')[0], lte: dur.split(',')[1] }
      }),
    level: postData.filters.level,
    category: postData.filters.categories,
    name: postData.filters.name
  }

  let requestUrl = `${API_ROOT}/api/embed/videos?url_prefix=${url_prefix}&region_id=${region_id}`
  let request = axios.post(requestUrl, filterData)

  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: VOD_VIDEOS, payload: data.data })
      })
      .catch(err => {
        dispatch({ type: VOD_VIDEOS_ERROR, payload: err })
      })
  }
}

export function getVideoUrl(vid, pid) {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/playlists/${pid}/videos/${vid}/url`

  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({
          type: VOD_VIDEO,
          payload: {
            ...data,
            vid
          }
        })
      })
      .catch(err => {
        dispatch({ type: VOD_VIDEO_ERROR, payload: err.response?.data })
      })
  }
}

export function getRentedVideos() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/profile/videos`

  let request = axios.get(requestUrl, axiosConfig)

  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({
          type: VOD_RENTED_VIDEOS,
          payload: data
        })
      })
      .catch(err => {
        dispatch({ type: VOD_RENTED_VIDEOS, payload: err.response })
      })
  }
}

export function getRentedPlaylists() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/profile/playlists`

  let request = axios.get(requestUrl, axiosConfig)

  return dispatch => {
    dispatch({ type: FETCHING_RENTED_PLAYLISTS })
    request
      .then(({ data }) => {
        dispatch({
          type: VOD_RENTED_PLAYLISTS,
          payload: data
        })
      })
      .catch(err => {
        dispatch({ type: VOD_RENTED_PLAYLISTS, payload: err.response })
      })
  }
}

export function getPlayListDetails(pid) {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/playlists/${pid}`

  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    dispatch({ type: FETCHING_PLAYLIST_DETAILS })
    request
      .then(({ data }) => {
        dispatch({ type: VOD_PLAYLIST_DETAILS, payload: data.data })
      })
      .catch(err => {
        dispatch({
          type: VOD_PLAYLIST_DETAILS_ERROR,
          payload: err.response?.data
        })
      })
  }
}

export function setSelectedVOD(data) {
  return dispatch =>
    dispatch({
      type: 'SET_SELECTED',
      payload: data
    })
}

export function clearVodData() {
  return dispatch =>
    dispatch({
      type: 'VOD_CLEAR'
    })
}
